/**
 * @generated SignedSource<<6dc69c71fbf7b3dfe06ae1e733a6fa15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type IntegrationType = "AWS" | "BITBUCKET" | "BUILDKITE" | "CAPABILITIES" | "CLOUDWATCH" | "CONFLUENCE" | "CURSOR" | "DATADOG" | "DEVIN" | "DISCORD" | "ELASTICSEARCH" | "FIREHYDRANT" | "GCP" | "GCP_CLOUD_MONITORING" | "GITHUB" | "GITLAB" | "GRAFANA_CLOUD" | "INCIDENT_IO" | "JIRA" | "LANGFUSE" | "LANGSMITH" | "LINEAR" | "NEW_RELIC" | "NOTION" | "OPENSEARCH" | "OPSGENIE" | "PAGERDUTY" | "PGANALYZE" | "POSTGRESQL" | "PROMETHEUS" | "ROLLBAR" | "ROOTLY" | "SENTRY" | "SLACK" | "SNOWFLAKE" | "SOCKET" | "TEMPORAL" | "%future added value";
export type ValidateIntegrationInput = {
  credentials: string;
  integrationId?: any | null | undefined;
  integrationType: IntegrationType;
};
export type DevinIntegrationFormValidateIntegrationMutation$variables = {
  input: ValidateIntegrationInput;
};
export type DevinIntegrationFormValidateIntegrationMutation$data = {
  readonly validateIntegration: {
    readonly error: string | null | undefined;
    readonly success: boolean;
  };
};
export type DevinIntegrationFormValidateIntegrationMutation = {
  response: DevinIntegrationFormValidateIntegrationMutation$data;
  variables: DevinIntegrationFormValidateIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ValidateIntegrationPayload",
    "kind": "LinkedField",
    "name": "validateIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DevinIntegrationFormValidateIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DevinIntegrationFormValidateIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1c362ff702ea0c3dedcfa8545496ee7a",
    "id": null,
    "metadata": {},
    "name": "DevinIntegrationFormValidateIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation DevinIntegrationFormValidateIntegrationMutation(\n  $input: ValidateIntegrationInput!\n) {\n  validateIntegration(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "6ea192fdad69258859bf808d9fa2b9a4";

export default node;
